import { FC } from 'react';
import { Button } from 'tedooo-web-design-system/ui';
import { Arrow } from 'tedooo-web-design-system/icons';

import { ISimilarShop, ISimilarShopsSection } from 'types';
import './similarShopsSection.scss';
import { Span } from 'components/helpers';
import { MultiItemCarouselSettings } from './multiItemsCarouselSettings';
import { MultiItemsCarousel } from 'components/carousels';
import { translations } from 'translations/en';
import ShopBox from 'components/shopBox/ShopBox';

const SimilarShopsSection: FC<ISimilarShopsSection> = ({
  shops,
  onSeeAllSimilarShops,
  onFollowToggle,
  onShopClick,
}) => {
  const title = translations.SHOP.SIMILAR_SHOPS;

  const buttonText = translations.SHOP.SEE_ALL_SIMILAR_SHOPS;

  const itemContent = (item: ISimilarShop) => {
    return (
      <ShopBox
        key={item.id}
        username={item.username}
        images={item.images}
        premium={item.isPremium}
        category={item.category}
        userId={item.userId}
        onShopClick={onShopClick}
        onFollowToggle={onFollowToggle}
        avatar={item.avatar}
        name={item.name}
        rating={item.rate}
        totalReviews={item.totalReviews}
        id={item.id}
        isFollowing={item.isFollowing}
        isVisionSeller={item.isVisionSeller}
      />
    );
  };

  return (
    <div className="shop-section section">
      <div className="header">
        <Span text={title} className="title" />
      </div>
      <div className="section-content similar-shop-section">
        <MultiItemsCarousel settings={MultiItemCarouselSettings} responsiveArrows={false}>
          {shops.map(itemContent)}
        </MultiItemsCarousel>
      </div>
      <Button
        borderRadius="small"
        type="tertiary"
        text={buttonText}
        size="small"
        suffixIcon={<Arrow />}
        onClick={onSeeAllSimilarShops}
      />
    </div>
  );
};

export default SimilarShopsSection;
